(function () {
  'use strict';

  function initMobileMenu(scope) {
    var button = scope.querySelector('[data-mobile-menu-button]');
    var nav = scope.querySelector('[data-mobile-nav]');
    if (!button || !nav || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';
    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
      document.documentElement.classList.toggle('menu-open', !open);
    });
  }

  function initSlideshows(scope) {
    scope.querySelectorAll('[data-slideshow]').forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slide-dot]'));
      if (!slides.length) return;
      var index = 0;
      var timer;
      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }
      function restart() {
        clearInterval(timer);
        if (root.dataset.autoplay === 'true' && slides.length > 1) timer = setInterval(function () { show(index + 1); }, Number(root.dataset.speed) || 5000);
      }
      var prev = root.querySelector('[data-slide-prev]');
      var next = root.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(index + 1); restart(); });
      dots.forEach(function (dot) { dot.addEventListener('click', function () { show(Number(dot.dataset.slideDot)); restart(); }); });
      restart();
    });
  }



  function initPromoCarousels(scope) {
    scope.querySelectorAll('[data-promo-carousel]').forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      var track = root.querySelector('[data-promo-track]');
      var prev = root.querySelector('[data-promo-prev]');
      var next = root.querySelector('[data-promo-next]');
      if (!track) return;
      var timer;

      function amount() {
        var card = track.querySelector('.promo-card');
        if (!card) return Math.max(track.clientWidth * 0.8, 280);
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function move(direction) {
        track.scrollBy({ left: direction * amount(), behavior: 'smooth' });
      }

      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (root.dataset.autoplay !== 'true') return;
        var speed = Number(root.dataset.speed) || 5000;
        timer = setInterval(function () {
          var nearEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
          if (nearEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
          else move(1);
        }, speed);
      }

      if (prev) prev.addEventListener('click', function () { move(-1); start(); });
      if (next) next.addEventListener('click', function () { move(1); start(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('touchstart', stop, { passive: true });
      root.addEventListener('touchend', start, { passive: true });
      start();
    });
  }

  function money(cents, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'AED' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function initProduct(scope) {
    scope.querySelectorAll('[data-product-section]').forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      var main = root.querySelector('[data-main-product-image]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-product-thumb]'));

      function showProductImage(thumb) {
        if (!thumb || !main) return;

        var nextSrc = thumb.getAttribute('data-image-src');
        var nextSrcset = thumb.getAttribute('data-image-srcset');
        var nextAlt = thumb.getAttribute('data-image-alt');

        // Update responsive image sources together. If srcset is left pointing to
        // the previous image, the browser can continue displaying that old image.
        if (nextSrcset) main.setAttribute('srcset', nextSrcset);
        else main.removeAttribute('srcset');
        if (nextSrc) main.setAttribute('src', nextSrc);
        if (nextAlt !== null) main.setAttribute('alt', nextAlt);

        thumbs.forEach(function (item) {
          var active = item === thumb;
          item.classList.toggle('is-active', active);
          if (active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          showProductImage(thumb);
        });
      });

      var json = root.querySelector('[data-product-json]');
      var variants = [];
      try { variants = JSON.parse(json.textContent); } catch (e) {}
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-position]'));
      var idInput = root.querySelector('[data-variant-id]');
      var atc = root.querySelector('[data-add-to-cart]');
      var atcText = root.querySelector('[data-atc-text]');
      var priceEl = root.querySelector('[data-variant-price]');
      var compareEl = root.querySelector('[data-variant-compare]');
      var shopCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';

      function updateVariant() {
        if (!selects.length || !variants.length) return;
        var values = selects.map(function (s) { return s.value; });
        var variant = variants.find(function (v) { return values.every(function (value, i) { return v.options[i] === value; }); });
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (atc) atc.disabled = !variant.available;
        if (atcText) atcText.textContent = variant.available ? (atc && atc.dataset.availableText ? atc.dataset.availableText : 'Add to cart') : (atc && atc.dataset.soldoutText ? atc.dataset.soldoutText : 'Sold out');
        if (priceEl) priceEl.textContent = money(variant.price, shopCurrency);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) { compareEl.textContent = money(variant.compare_at_price, shopCurrency); compareEl.classList.remove('hidden'); }
          else compareEl.classList.add('hidden');
        }
        if (variant.featured_media && main) {
          var matching = root.querySelector('[data-product-thumb][data-media-id="' + variant.featured_media.id + '"]');
          if (matching) matching.click();
        }
        try { history.replaceState({}, '', location.pathname + '?variant=' + variant.id); } catch (e) {}
      }
      selects.forEach(function (select) { select.addEventListener('change', updateVariant); });
    });
  }

  function init(scope) {
    initMobileMenu(scope);
    initSlideshows(scope);
    initPromoCarousels(scope);
    initProduct(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
